import React from "react";
import { useState } from "react";
import { useEffect,useRef } from "react";
import { toast } from "react-toastify";
import Spinner from "../../../common/Spinner/Spinner";
import { getUser } from "../../../utils/localStorage";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "../../../common/Pagination/Pagination";
import { getServiceTypesMaster } from "../../../utils/localStorage";
import find from "lodash/find";
import moment from "moment";
import { Button } from "../../../common/Button/Button";
import Checkbox from "../../../common/Checkbox/Checkbox";
import copysvg from "./../../../assets/arrow_copy.svg";
import ColumnSelectionDropdown from "./ColumnSelectionDropdown";
import arrow_right from "../../../assets/ic_header_arrow_right.svg";
import arrow_left from "../../../assets/ic_header_arrow_left.svg";
import arrow_more from "../../../assets/ic_more.svg";
import ColumnSectionDropdown from "./ColumnSelectionDropdown";
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function AdminServiceRequestsGrid(props)
{
	const [columnPage,setcolumnPage] =useState(0);
	const [selectedColumnsCount,setSelectedColumnCount] =useState(0);

    const copyToClipboard = (content) => {
		const el = document.createElement('textarea');
		el.value = content;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};

    const getServiceName = (original) => {
		if (!original) return;
		const found = find(getServiceTypesMaster(), {
			sServiceCode: original.sServiceCode,
		});
		if (found) {
			return found.sServiceName;
		}
		return "";
	};

	const generateColumns=()=>{

		let selectedColumnCount =0;
		let currentCount =0;
		let colPage=columnPage;

        const columns = [
					{
						id: "checkbox",
						accessor: "",
						Cell: ({ original }) => {
							return (
									<label className="checkbox-container">
										<input type="checkbox"
											onChange={() => {
												const updated = props.selectedServiceRequests.addOrUpdate(
													original,
													"nResourceInstanceId"
												);
												props.onSelectServiceRequest(updated);
											}}
											checked={
												find(props.selectedServiceRequests, {
													nResourceInstanceId:
														original.nResourceInstanceId,
												}) !== undefined
											}
										/>
										<span className="table-checkbox"></span>
									</label>
									/*<input
										type="checkbox"
										className="checkbox"
										onChange={() => {
											const updated = props.selectedServiceRequests.addOrUpdate(
												original,
												"nResourceInstanceId"
											);
											props.onSelectServiceRequest(updated);
										}}
										checked={
											find(props.selectedServiceRequests, {
												nResourceInstanceId:
													original.nResourceInstanceId,
											}) !== undefined
										}
										//checked={this.state.selected[original.firstName] === true}
										//onChange={() => this.toggleRow(original.firstName)}
									/>*/
							);
						},
						Header: x => {
							return (
									/*<input
										type="checkbox"
										className="checkbox"
										checked={props.selectedServiceRequests.length === parseInt(props.pageSize)}
										onChange={() => {
										const updated = props.selectedServiceRequests.toggleAll(
											x.data,
											"_original"
										);
										props.onSelectServiceRequest(updated);
										}}
										//checked={this.state.selectAll === 1}
										//ref={input => {
										//	if (input) {
										//		input.indeterminate = this.state.selectAll === 2;
										//	}
										//}}
										//onChange={() => this.toggleSelectAll()}
									/>*/
									<label className="checkbox-container">
										<input type="checkbox"
											checked={props.selectedServiceRequests.length === parseInt(props.pageSize)}
											onChange={() => {
											const updated = props.selectedServiceRequests.toggleAll(
												x.data,
												"_original"
											);
											props.onSelectServiceRequest(updated);
											}}
										/>
										<span className="table-checkbox"></span>
									</label>
								
							);
						},
						sortable: false,
						width: 50
					},  
			/*{
				id: "checkbox",
				accessor: "nResourceInstanceId",
				Header: (header) => {
					return (
						<>
								<Checkbox
								id={`checkbox-id-header`}
								checked={props.selectedServiceRequests.length === parseInt(props.pageSize)}
								onChange={() => {
									const updated = props.selectedServiceRequests.toggleAll(
										header.data,
										"_original"
									);
									props.onSelectServiceRequest(updated);
								}}
							/>
						</>
						
					);
				},
				Cell: ({ original }) => {
					return (
						<Checkbox
							id={`checkbox-id-${original.nResourceInstanceId}`}
							onChange={() => {
								const updated = props.selectedServiceRequests.addOrUpdate(
									original,
									"nResourceInstanceId"
								);
								props.onSelectServiceRequest(updated);
							}}
							checked={
								find(props.selectedServiceRequests, {
									nResourceInstanceId:
										original.nResourceInstanceId,
								}) !== undefined
							}
						/>
					);
				},
				width: 45,
				//sortable: false,
				//resizable: false,
				// show: false
			},   
			/*{
				id: "nResourceInstanceId",
				headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
				Header: "Service Name + Service ID",
				accessor: "nResourceInstanceId",
				style: { 'whiteSpace': 'unset'},
				width:200,
				Cell:({original})=>(
					<>
						<span>
							{
								original.sServiceName ? 
								original.sServiceName :
								getServiceName(original)
							}
						</span><br></br>
						<span>
							{`ID:${original.nResourceInstanceId}`}
						</span>
					</>
				)
				
			},
			{
				id: "nPackageInstanceId",
				Header: "Package Details",
				headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
				accessor: "nPackageInstanceId",
				style: { 'whiteSpace': 'unset'},
				width:200,
				Cell:({original})=>(				
					<>
						{
							original.sPackageOfferTitle||original.nPackageInstanceId?
							(
								<>
									<span>
										{
											original.sPackageOfferTitle ? 
											original.sPackageOfferTitle :
											""
										}
									</span><br></br>
									<span>
										{`ID:${original.nResourceInstanceId}`}
									</span>
								</>
							)
							:("")
						}					
					</>
				)
			},
			{
				id: "sEmailAddress",
				Header: "Customer Detail",
				headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
				accessor: "sEmailAddress",
				style: { 'whiteSpace': 'unset'},
				width:350,
				Cell: ({ original }) => (
					<>
						<div className={"conv-float-left conv-mr10"}>
							{
								original.bUserInSPM?(<><div><span className={"yellow-dot"} title="User in SPM"></span></div><br></br></>):("")
							}
							{
								original.bMovedToSPM?(<><div><span  className={"blue-dot"} title="Moved To SPM"></span></div><br></br></>):("")
							}
							{
								original.bStayEngagedWithEhh?(<><div><span className={"green-dot"} title="Stay Engaged with EHH"></span></div></>):("")
							}
						</div>
						<div className={"conv-float-left"}>
							<div>
								<span className="conv-float-left conv-mr18">Name:</span>
								{
									original.sEmailAddress?
									(
										<>
											<img
												alt="copy"
												src={copysvg}
												height={"20px"}
												width={"16px"}
												className="con-cursor-pointer conv-mr13 conv-ml10"
												onClick={(e) => {
													e.preventDefault();
													copyToClipboard(original.sEmailAddress);
													toast(`${
														original.sFirstName ? 
														original.sFirstName :
														""
													}${' '}
													${
														original.sLastName ? 
														original.sLastName :
														""
													}'s Email Copied!`, {
														autoClose: 5000,
														type: toast.TYPE.SUCCESS,
													});
												}}
											/>
											<span style={{wordBreak:"break-all",float:"right",width:"200px"}}>
												
												{
													original.sEmailAddress
												}
											</span><br></br>
										</>
									)
									:
									("NA")
								}
							</div>
							<div style={{"clear":"both"}}></div>
							<div className="conv-mt10">
							<span className="conv-float-left conv-mr5">Contact:</span>
								{
									original.sContactNumber?
									(
										<>
											<img
												alt="copy"
												src={copysvg}
												height={"20px"}
												width={"16px"}
												className="con-cursor-pointer conv-mr13 conv-ml10"
												onClick={(e) => {
													e.preventDefault();
													copyToClipboard(original.sEmailAddress);
													toast(`${
														original.sFirstName ? 
														original.sFirstName :
														""
													}${' '}
													${
														original.sLastName ? 
														original.sLastName :
														""
													}'s Contact Copied!`, {
														autoClose: 5000,
														type: toast.TYPE.SUCCESS,
													});
												}}
											/>
											<span style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
												{
													original.sContactNumber
												}
											</span>
										</>
									)
									:
									("")
								}
							</div>
						</div>			
					</>
				),
			},*/
			
		];

		props.ColumnDropdownList.map((x) => {
            if (x.checked) 
			{
				selectedColumnCount++;
            }
        });

		if(selectedColumnsCount!=selectedColumnCount)
		{
			setSelectedColumnCount(selectedColumnCount);
		}

		

		if(columnPage!==0&&selectedColumnCount<=5)
		{
			colPage=0;
			setcolumnPage(0);
		}

		props.ColumnDropdownList.map((x) => {
            if (x.checked) 
			{
				currentCount++;
				if(x.code==="ServiceName")
				{
					columns.push(
						{
							id: "nResourceInstanceId",
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							Header:<>
							{
								currentCount==selectedColumnCount?
								(
									<div>Service Name + Service ID
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Service Name + Service ID"
								)
							}
							</>,
							width:200,
							accessor: "nResourceInstanceId",
							style: { 'whiteSpace': 'unset'},
							Cell:({original})=>(
								<>
									<span>
										{
											(original.sServiceCode === "MKTLINKAGEEXHIBITION" || original.sServiceCode === "MKTLINKAGEBULKBUYER" ||
											original.sServiceCode === "MKTLINKAGEECOM" ||original.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
											original.sServiceCode === "MKTLINKAGESHOPINSHOP" ||original.sServiceCode === "MKTLINKAGEEXPORT")  && original.sServiceDisplayName ?
											original.sServiceName ? 
											original.sServiceName + " " + `(${original.sServiceDisplayName})` :
											getServiceName(original)
											:
											original.sServiceName + " " + `(${original.sServiceDisplayName})` ? 
											original.sServiceName :
											getServiceName(original)
										}
									</span><br></br>
									<span>
										{`ID:${original.nResourceInstanceId}`}
									</span>
								</>
							)							
						},
					)
				}
				else if(x.code==="PackageDetails")
				{
					columns.push(
						
						{
							id: "nPackageInstanceId",
							//Header: "Package Details",
							Header:<>
							{
								currentCount==selectedColumnCount?
								(
									<div>Package Details
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Package Details"
								)
							}
							</>,
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "nPackageInstanceId",
							style: { 'whiteSpace': 'unset'},
							width:150,
							Cell:({original})=>(				
								<>
									{
										original.sPackageOfferTitle||original.nPackageInstanceId?
										(
											<>
												<span>
													{
														original.sPackageOfferTitle ? 
														original.sPackageOfferTitle :
														""
													}
												</span><br></br>
												<span>
													{`ID:${original.nPackageInstanceId}`}
												</span>
											</>
										)
										:("")
									}					
								</>
							)
						},
					)
				}
				else if(x.code==="CustomerDetails")
				{
					columns.push(						
						{
							id: "sEmailAddress",
							//Header: "Customer Detail",
							Header:<>
							{
								currentCount==selectedColumnCount?
								(
									<div>Customer Detail
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Customer Detail"
								)
							}
							</>,
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "sEmailAddress",
							style: { 'whiteSpace': 'unset'},
							width:350,
							Cell: ({ original }) => (
								<>
									<div className={"conv-float-left conv-mr10"}>
										{
											original.bUserInSPM?(<><div><span className={"yellow-dot"} title="User in SPM"></span></div><br></br></>):("")
										}
										{
											original.bMovedToSPM?(<><div><span  className={"blue-dot"} title="Moved To SPM"></span></div><br></br></>):("")
										}
										{
											original.bStayEngagedWithEhh?(<><div><span className={"green-dot"} title="Stay Engaged with EHH"></span></div></>):("")
										}
									</div>
									<div className={"conv-float-left"}>
										<div>
											<span className="conv-float-left conv-mr18 lpm-service-grid-key">Email:</span>
											{
												original.sEmailAddress?
												(
													<>
														<img
															alt="copy"
															src={copysvg}
															height={"20px"}
															width={"16px"}
															className="con-cursor-pointer conv-mr13 conv-ml10"
															onClick={(e) => {
																e.preventDefault();
																copyToClipboard(original.sEmailAddress);
																toast(`${
																	original.sFirstName ? 
																	original.sFirstName :
																	""
																}${' '}
																${
																	original.sLastName ? 
																	original.sLastName :
																	""
																}'s Email Copied!`, {
																	autoClose: 5000,
																	type: toast.TYPE.SUCCESS,
																});
															}}
														/>
														<span className="lpm-service-grid-value" style={{wordBreak:"break-all",float:"right",width:"200px"}}>
															
															{
																original.sEmailAddress
															}
														</span><br></br>
													</>
												)
												:
												("NA")
											}
										</div>
										<div style={{"clear":"both"}}></div>
										<div className="conv-mt10">
										<span className="conv-float-left conv-mr5 lpm-service-grid-key">Contact:</span>
											{
												original.sContactNumber?
												(
													<>
														<img
															alt="copy"
															src={copysvg}
															height={"20px"}
															width={"16px"}
															className="con-cursor-pointer conv-mr13 conv-ml10"
															onClick={(e) => {
																e.preventDefault();
																copyToClipboard(original.sContactNumber);
																toast(`${
																	original.sFirstName ? 
																	original.sFirstName :
																	""
																}${' '}
																${
																	original.sLastName ? 
																	original.sLastName :
																	""
																}'s Contact Copied!`, {
																	autoClose: 5000,
																	type: toast.TYPE.SUCCESS,
																});
															}}
														/>
														<span className="lpm-service-grid-value" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{
																original.sContactNumber
															}
														</span>
													</>
												)
												:
												("")
											}
										</div>
									</div>			
								</>
							),
						},
					)
				}
				else if(x.code==="Handholder")
				{
					columns.push(
						{
							id: "refHH",
							//Header: "Handholder",
							Header:<>
							{
								currentCount==5||currentCount==selectedColumnCount?
								(
									<div>Handholder
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Handholder"
								)
							}
							</>,
							show:(currentCount<=5&&colPage==0)?true:false,
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "refHH",
							style: { 'whiteSpace': 'unset' },
							//width:200,
							Cell: ({ original }) => (
								<span style={{wordBreak:"break-all"}}>
									{original.refHH?
										original.refHH:
										""}
								</span>
								
							),
						},
					)
				}
				else if(x.code==="Facilitator")
				{
					columns.push(
						{
							id: "refFacilitator",
							//Header: "Facilitator",
							Header:<>
							{
								currentCount==5||currentCount==selectedColumnCount?
								(
									<div>Facilitator
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																let count =colPage==0?1:0
																setcolumnPage(count);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Facilitator"
								)
							}
							</>,
							show:(currentCount<=5&&colPage==0)?true:false,
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "refFacilitator",
							style: { 'whiteSpace': 'unset' },
							//width:200,
							Cell: ({ original }) => (
								<>
									<span style={{wordBreak:"break-all"}}>
									{original.refFacilitator?
									original.refFacilitator:
									""}
								</span>
								</>
								
								
							),
						},
					)
				}
				else if(x.code==="ServicePartner")
				{
					columns.push(
						{
							id: "refExternalServicePartner",
							//Header: "Service Partner",
							Header:<>
							{
								currentCount==5||currentCount==selectedColumnCount?
								(
									<div>Service Partner
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Service Partner"
								)
							}
							</>,
							show:(currentCount<=5&&colPage==0)||(currentCount>5&&selectedColumnCount>5&&colPage==1)?true:false,
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "refExternalServicePartner",
							style: { 'whiteSpace': 'unset' },
							//width:200,
							Cell: ({ original }) => (
								original.refExternalServicePartner?
								<span style={{wordBreak:"break-all"}}>
									{original.refExternalServicePartner}{original.ext_sp_org? (" ("+original.ext_sp_org+")"): ""}
								</span>				
								:
								""
							),
						},


					)
				}
				else if(x.code==="CreatedOn")
				{
					columns.push(
						{
							id: "dtRequested",
							//Header: "Created On",
							Header:<>
							{
								currentCount==5||currentCount==selectedColumnCount?
								(
									<div>Created On
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Created On"
								)
							}
							</>,
							//width:120,
							show:(currentCount<=5&&colPage==0)||(currentCount>5&&selectedColumnCount>5&&colPage==1)?true:false,
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "dtRequested",
							style: { 'whiteSpace': 'unset' },
							Cell: ({ original }) =>
							original.dtRequested?(moment(original.dtRequested).format("DD/MM/YYYY")):("NA"),
						},
					)
				}
				else if(x.code==="FollowUpOn")
				{
					columns.push(
						{
							id: "dtFollowupOn",
							Header: "Follow Up On",
							Header:<>
							{
								currentCount==5||currentCount==selectedColumnCount?
								(
									<div>Follow Up On
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Follow Up On"
								)
							}
							</>,
							//width:120,
							show:(currentCount<=5&&colPage==0)||(currentCount>5&&selectedColumnCount>5&&colPage==1)?true:false,
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "dtFollowupOn",
							style: { 'whiteSpace': 'unset' },
							Cell: ({ original }) =>
							original.dtFollowupOn?(moment(original.dtFollowupOn).format("DD/MM/YYYY")):("NA"),
						},
					)
				}
				else if(x.code==="Status")
				{
					columns.push(
						{
							id: "refSRState",
							//Header: "Status",
							Header:<>
							{
								currentCount==5||currentCount==selectedColumnCount?
								(
									<div>Status
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Status"
								)
							}
							</>,
							//width:120,
							show:(currentCount<=5&&colPage==0)||(currentCount>5&&selectedColumnCount>5&&colPage==1)?true:false,
							style: { 'whiteSpace': 'unset' },
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "refSRState",
						}
					)
				}
            }
        });

		/*if(columnPage==0)
		{
			columns.push(
				{
					id: "refHH",
					Header: "Handholder",
					headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
					accessor: "refHH",
					style: { 'whiteSpace': 'unset' },
					//width:200,
					Cell: ({ original }) => (
						<span style={{wordBreak:"break-all"}}>
							{original.refHH?
								original.refHH:
								""}
						</span>
						
					),
				},
				{
					id: "existing_service_facilitator",
					//Header: "Facilitator",
					Header:<div>Facilitator

					<div className="conv-float-right" style={{'width':'25px'}}>
						<img
								alt=""
								style={{'color':'white'}}
								src={arrow_more}
								height={"20px"}
								width={"20px"}
								className=""
								onClick={()=>{
									props.toggleColumnVisibility();
								}}
							/>
						<img
							alt=""
							src={arrow_right}
							height={"20px"}
							width={"20px"}
							className=""
							onClick={()=>{
								setcolumnPage(1);
							}}
						/>
					</div>
					
				</div>,
					headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
					accessor: "existing_service_facilitator",
					style: { 'whiteSpace': 'unset' },
					//width:200,
					Cell: ({ original }) => (
						<>
							<span style={{wordBreak:"break-all"}}>
							{original.existing_service_facilitator&&original.existing_service_facilitator.email?
							original.existing_service_facilitator.email:
							""}
						</span>
						</>
						
						
					),
				},
				
			);
		}
		else
		{
			columns.push(
				{
					id: "refExternalServicePartner",
					Header: "Service Partner",
					headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
					accessor: "refExternalServicePartner",
					style: { 'whiteSpace': 'unset' },
					//width:200,
					Cell: ({ original }) => (
						original.refExternalServicePartner?
						<span style={{wordBreak:"break-all"}}>
							{original.refExternalServicePartner}{original.ext_sp_org? (" ("+original.ext_sp_org+")"): ""}
						</span>				
						:
						""
					),
				},
				{
					id: "dtRequested",
					Header: "Created On",
					//width:120,
					headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
					accessor: "dtRequested",
					style: { 'whiteSpace': 'unset' },
					Cell: ({ original }) =>
					original.dtRequested?(moment(original.dtRequested).format("DD/MM/YYYY")):("NA"),
				},
				{
					id: "dtFollowupOn",
					Header: "Follow Up On",
					//width:120,
					headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
					accessor: "dtFollowupOn",
					style: { 'whiteSpace': 'unset' },
					Cell: ({ original }) =>
					original.dtRequested?(moment(original.dtFollowupOn).format("DD/MM/YYYY")):("NA"),
				},
				{
					id: "refSRState",
				//	Header: "Status",
					Header:<div>Status
					<img
						alt=""
						src={arrow_left}
						height={"20px"}
						width={"20px"}
						className="conv-ml15 conv-float-right"
						onClick={()=>{
							setcolumnPage(0);
						}}
					/></div>,
					//width:120,
					style: { 'whiteSpace': 'unset' },
					headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
					accessor: "refSRState",
				}
			);
		}*/



		/*if(props.ColumnDropdownList[0].checked)
		{
			columns.push(
				{
					id: "refHH",
					Header: "Handholder",
					headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
					accessor: "refHH",
					style: { 'whiteSpace': 'unset' },
					width:200,
					Cell: ({ original }) => (
						<span style={{wordBreak:"break-all"}}>
							{original.refHH?
								original.refHH:
								""}
						</span>
						
					),
				}
			);
		}

		if(props.ColumnDropdownList[1].checked)
		{
			columns.push(
				{
					id: "existing_service_facilitator",
					Header: "Facilitator",
					headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
					accessor: "existing_service_facilitator",
					style: { 'whiteSpace': 'unset' },
					width:200,
					Cell: ({ original }) => (
						<>
							<span style={{wordBreak:"break-all"}}>
							{original.existing_service_facilitator&&original.existing_service_facilitator.email?
							original.existing_service_facilitator.email:
							""}
						</span>
						</>
						
						
					),
				}
			);
		}

		if(props.ColumnDropdownList[2].checked)
		{
			columns.push(
				{
					id: "refExternalServicePartner",
					Header: "Service Partner",
					headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
					accessor: "refExternalServicePartner",
					style: { 'whiteSpace': 'unset' },
					width:200,
					Cell: ({ original }) => (
						original.refExternalServicePartner?
						<span style={{wordBreak:"break-all"}}>
							{original.refExternalServicePartner}{original.ext_sp_org? (" ("+original.ext_sp_org+")"): ""}
						</span>				
						:
						""
					),
				}
			);
		}

		if(props.ColumnDropdownList[3].checked)
		{
			columns.push(
				{
					id: "dtRequested",
					Header: "Created On",
					width:120,
					headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
					accessor: "dtRequested",
					style: { 'whiteSpace': 'unset' },
					Cell: ({ original }) =>
					original.dtRequested?(moment(original.dtRequested).format("DD/MM/YYYY")):("NA"),
				}
			);
		}

		if(props.ColumnDropdownList[4].checked)
		{
			columns.push(
				{
					id: "dtFollowupOn",
					Header: "Follow Up On",
					width:120,
					headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
					accessor: "dtFollowupOn",
					style: { 'whiteSpace': 'unset' },
					Cell: ({ original }) =>
					original.dtRequested?(moment(original.dtFollowupOn).format("DD/MM/YYYY")):("NA"),
				}
			);
		}

		if(props.ColumnDropdownList[5].checked)
		{
			columns.push(
				{
					id: "refSRState",
					Header: "Status",
					width:120,
					style: { 'whiteSpace': 'unset' },
					headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
					accessor: "refSRState",
				}
			);
		}*/

        return columns;
	} 
	
    return (
        <div className="col-12 conv-mt25 conv-pl40 conv-pr40 spled-container fix-filter">
			<div className="spled-container">
				<div className={`service-partner spled-container`}>
					{
						props.isColumnDropdownOpen &&
						<div ref={props.ColumnDropdownRef}>
							<ColumnSectionDropdown
								isOpen={props.isColumnDropdownOpen}
								toggleSelection={props.toggleColumnSelection}
								checkboxItemsList={props.ColumnDropdownList}
								
							/>
						</div>
					}

					{<ReactTableFixedColumns
						minRows={0}
						data={props.data || []}
						columns={generateColumns()}
						manual
						defaultPage={props.page}
						pages={props.pages}
						page={props.page}
						pageSize={props.pageSize}
						sortable={false}
						defaultPageSize={10}
						showPagination={true}
						pageSizeOptions={[10,20,30,50,75,100]}
						onFetchData={(state, instance) => {
							props.onFetchServiceRequests(instance, false);
						}}
						onPageSizeChange={props.onPageSizeOptionChange}
						PaginationComponent={Pagination}
						style={{overflowY: "initial",height: "390px"}}			
						className="-striped hide-scrollbar"
					/>}
				</div>
			</div>			
        </div>
	);

}